import { z } from 'zod'
import { REASONING_LABELS, REASONING_VALUES } from './constants'

export const DecisionSchema = z.enum(['accepted', 'rejected'], {
  message: 'Please select a decision.',
})

export type Decision = z.infer<typeof DecisionSchema>

export const ReasoningInputSchema = z.enum(REASONING_LABELS, {
  errorMap: () => ({ message: 'Please select a valid reasoning.' }),
})

export type ReasoningInput = z.infer<typeof ReasoningInputSchema>

/**
 * What a reviewer is allowed to pick. `No selection` only ever arrives from the
 * API as the default for never reviewed records, so it is excluded here instead
 * of being validated away after the fact.
 */
export const SelectableReasoningSchema = ReasoningInputSchema.exclude([
  'No selection',
])

export type SelectableReasoning = z.infer<typeof SelectableReasoningSchema>

/** Turns the reviewer facing label into the numeric value the API expects. */
export const ReasoningSchema = ReasoningInputSchema.transform(
  (label) => REASONING_VALUES[label]
)

/**
 * The four fields every admin review answers with: the decision itself, why it
 * was taken, an internal note that never leaves the portal and the reply the
 * applicant/provider actually reads.
 */
export const ReviewDecisionFormSchema = z.object({
  decision: DecisionSchema,
  reasoning: SelectableReasoningSchema,
  justification: z.string().min(1, { message: 'Internal note is required' }),
  public_reply: z.string().nullable().optional(),
})

export type ReviewDecisionFormData = z.infer<typeof ReviewDecisionFormSchema>
